export const PRICE_TYPE_RANGE = 'PRICE_RANGE';
export const PRICE_TYPE_AVERAGE = 'PRICE_AVERAGE';
export const PRICE_TYPE_LOW = 'PRICE_LOW';

export const PRICE_PERIOD_WEEKLY = 'WEEKLY';
export const PRICE_PERIOD_NIGHTLY = 'NIGHTLY';
